<template>
    <form
        class="form basic-form trip-form"
        autocomplete="off"
        novalidate
        @submit="emitSubmit"
    >
        <div class="form-field">
            <label for="email">Email:</label>
            <input
                id="email"
                v-model="form.email.value"
                type="email"
                autocomplete="email"
            />
            <FormError :errors="errors.email" />
        </div>
        <div class="form-buttons center">
            <Bttn id="submit-register" type="submit">Save</Bttn>
        </div>
        <div v-if="!!successMessage" class="form-message">
            {{ successMessage }}
        </div>
    </form>
</template>

<script>
import BaseForm from "js/components/base/BaseForm.js";
import FormError from "js/components/forms/FormError";

export default {
    name: "RegisterForm",
    components: {
        FormError,
    },
    extends: BaseForm,
    data() {
        return {
            form: {
                email: {
                    value: "",
                },
            },
        };
    },
};
</script>
